import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import numberValidation from 'utils/validations/numberValidation';
import pismenaCislaValidation from 'utils/validations/pismenaCislaValidation';
import { rcmaValidationSimple } from 'utils/validations/rcmaValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF7 {}

const F7: React.FC<IF7> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();

    const [nepovinneValErr, setNepovinneValErr] = useState<boolean>(false);
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (fieldsValue.idmb || fieldsValue.rcma || fieldsValue.idsp) {
            const dataToSend = {
                ...fieldsValue,
                dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
            };
            onFormSubmit(dataToSend);
        } else {
            setNepovinneValErr(true);
        }
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F7" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f7ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <LoadingWrapper loading={dateLoading}>
                                <DatePickerComponent
                                    name="dtvp"
                                    label="DUVERNE_INFO_POZADOVANY_DEN"
                                    disabled={currentStep > 0}
                                    disabledDate={current => commonDisabledDate(current)}
                                />
                            </LoadingWrapper>
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_MAJITEL_SHORT"
                                name="idmb"
                                rules={pismenaCislaValidation()}
                                notRequired={true}
                                type="text"
                                maxLength={50}
                                hide={currentStep === 1 && !form.getFieldValue('idmb')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_PREDCISLI_UCTU"
                                name="cdac"
                                type="text"
                                maxLength={4}
                                rules={numberValidation()}
                                notRequired={true}
                                hide={currentStep === 1 && !form.getFieldValue('cdac')}
                                disabled={currentStep > 0}
                            />
                            <InputComponent
                                label="CISLO_UCTU"
                                name="rcma"
                                type="text"
                                rules={rcmaValidationSimple()}
                                notRequired={true}
                                maxLength={12}
                                hide={currentStep === 1 && !form.getFieldValue('rcma')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_SPRAVCE"
                                name="idsp"
                                type="text"
                                maxLength={100}
                                notRequired={true}
                                hide={currentStep === 1 && !form.getFieldValue('idsp')}
                                disabled={currentStep > 0}
                                onChange={() => setNepovinneValErr(false)}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                            />
                            {currentStep !== 0 && upozorneni && (
                                <AlertComponent upozorneni={upozorneni} type={currentStep === 1 ? 'error' : 'info'} />
                            )}
                            <Row className="button-row">
                                {currentStep === 1 && (
                                    <ButtonComponent
                                        id="f7ZpetAltBtn"
                                        buttontext="ZPET"
                                        onClick={() => prev()}
                                        type="default"
                                    />
                                )}
                                <ButtonComponent id="f7OdeslatBtn" buttontext="ODESLAT" onClick={() => form.submit()} />
                            </Row>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F7;
